export const initialState = {
  token: localStorage.getItem("token"),
  loading:false,
};
